import { render, staticRenderFns } from "./printing_Services.vue?vue&type=template&id=ccf96daa&scoped=true"
import script from "./printing_Services.vue?vue&type=script&lang=js"
export * from "./printing_Services.vue?vue&type=script&lang=js"
import style0 from "./printing_Services.vue?vue&type=style&index=0&id=ccf96daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf96daa",
  null
  
)

export default component.exports